import { create } from 'zustand';

import { THEMES, THEME_IS_DARK_THEME, THEME_LS_ITEM } from "~/const";

interface IThemeStore {
	theme: {
		isDark: boolean;
		colors: {
			[key: string]: string;
		}
	}
	setLightTheme: () => void;
	setDarkTheme: () => void;
}

const isDark = matchMedia(THEME_IS_DARK_THEME).matches;
const isDarkLs = localStorage.getItem(THEME_LS_ITEM) === "1";

export const themeStore = create<IThemeStore>(set => ({
	theme: {
		isDark: isDark || isDarkLs,
		colors: {
			...isDark || isDarkLs ? THEMES.dark : THEMES.light,
		},
	},
	setLightTheme: () => set(() => ({
		theme: {
			isDark: false,
			colors: {
				...THEMES.light,
			},
		},
	})),
	setDarkTheme: () => set(() => ({
		theme: {
			isDark: true,
			colors: {
				...THEMES.dark,
			},
		},
	})),
}));
